<template>
    <div class="register-step1-2 register-section">
        <Form class="pop-common-form" :form="registerForm" @submit="handleSubmit">
            <FormItem class="form-item" label="电子邮箱" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
                <Input v-decorator="['email',
                {
                    rules: rules.email,
                    validateFirst: true
                }
                ]"
                placeholder="请输入邮箱"
                />
                <div class="form-help" v-show="show"><img src="../../../../assets/images/icon-notice.png">用于找回密码、接收通知</div>
            </FormItem>
            <FormItem v-bind="tailFormItemLayout">
                <Button type="primary" html-type="submit" :disabled="isDisable">下一步</Button>
                <Button class="noraml-bt" @click="goback">返回修改验证手机号</Button>
            </FormItem>
        </Form>
        <Modal class="register-modal" v-model="visible" :footer="null" :width="500" >
            <template slot="title">
                <Head class="modal-title" title="邮箱绑定"></Head>
            </template>
            <div class="register-modal-content">
                <p>验证邮件已经发送到{{registerForm.getFieldValue('email')}} <a @click="closeModal">更换邮箱</a></p>
                <p>请登录邮箱，点击激活链接，激活链接24小时内有效</p>
                <p class="tip">没有收到邮件？<a @click="sendEmail">重新发送</a></p>
                <p class="tip-check">重发仍未收到，请确认您提供的邮箱是否设置了自动拦截，或被误认为垃圾邮件了</p>
            </div>
        </Modal>
    </div> 
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { Form, Input, Button, notification, Modal } from 'ant-design-vue'
import { Base64 } from 'js-base64'
import Head from '@components/title'
import FormUtil from '@utils/form'
import FormMix from '../../formMixins'
import { util } from '@utils';

export default {
    data() {
        return {
            // form: this.$form.createForm(this, {
            //     onFieldsChange: (_, changedFields) => {
                    
            //     },
            // }),
            visible: false,
            form: {}
        }
    },
    mixins: [FormUtil, FormMix],
    methods: {
        ...mapMutations('register', ['setStepId', 'setRegInfo']),
        handleSubmit(e) {
            e.preventDefault();
            this.registerForm.validateFields((error, values) => {
                if (!error) {
                    this.visible = true
                    this.sendEmail()
                }
                return;
            });
        },
        async sendEmail() {
            const email = this.registerForm.getFieldValue('email')
            let source = ''
            if (util.isNc()) {
                source = 'ncsupplier-portal'
            }
            await this.$store.dispatch('sendEmail', {
                recipients: email,
                type: '1',
                url: encodeURIComponent(`https://open.haiziwang.com/auth/register?step=2&email=${Base64.encode(email)}&phone=${Base64.encode(this.regInfo.phone)}&source=${source}`)
            })
        },
        async validateEmail(rule, value, cb) {
            const flag = await this.validEmail(value)
            if (flag) {
                cb('邮箱已经存在')
            }
            cb()
        },
        closeModal() {
            this.visible = false
        },
        goback() {
            this.setStepId(1)
        }
    },
    computed: {
        ...mapState('register', {
            regInfo: state => state.regInfo,
            layout: state => state.layout
        }),
    },
    components: {
        Form,
        FormItem: Form.Item,
        Input,
        Button,
        Modal,
        Head
    }
}
</script>

<style lang="scss">
.register-step1-2{
    .ant-form-item-children{
        display: flex;
    }
}
.register-modal{
    .ant-modal-header{
        padding: 8px 15px;
        font-size: 14px;
        color: #333333;
        background: #F7F7F7;
    }
    .ant-modal-close-x{
        height: 40px;
        line-height: 40px;
    }
    .ant-modal-body{
        padding: 0;
    }
}

</style>
<style lang="scss" scoped>
.modal-title{
    padding: 0;
}
.register-modal{
    .register-modal-content{
        padding: 60px 80px;
        font-size: 14px;
        color: #333;
        p{
            padding-bottom: 10px;
        }
        .tip{
            font-size: 12px;
        }
        .tip-check{
            font-size: 12px;
            color: #999;
        }

        a{
            text-decoration: underline;
        }
    }
}
</style>